/*
  Obsługa strzałek nawigacyjnych w widżecie product-recommendations.
  - widoczne tylko gdy lista produktów się nie mieści (scrollWidth > clientWidth)
  - przewijają o szerokość jednej karty
  - stan is-disabled na początku/końcu listy
  - reagują na scroll (też ręczny), resize i mutacje DOM (rekomendacje dociągane async przez S&D)
*/
(function () {
  'use strict';

  var DESKTOP_BREAKPOINT = 1025; // strzałki działają od tej szerokości w górę

  function initCarousel(carousel) {
    if (carousel.dataset.recommendationsInit === '1') return;
    carousel.dataset.recommendationsInit = '1';

    var track = carousel.querySelector('[data-recommendations-track]');
    var prevBtn = carousel.querySelector('[data-recommendations-prev]');
    var nextBtn = carousel.querySelector('[data-recommendations-next]');

    if (!track || !prevBtn || !nextBtn) return;

    function isDesktop() {
      return window.matchMedia('(min-width: ' + DESKTOP_BREAKPOINT + 'px)').matches;
    }

    function getStep() {
      // szerokość pierwszej widocznej karty - na tyle przewijamy
      var firstCard = track.querySelector('li.columns:not([style*="display: none"])');
      if (!firstCard) return 327;
      var rect = firstCard.getBoundingClientRect();
      return rect.width || 327;
    }

    function updateState() {
      if (!isDesktop()) {
        carousel.classList.remove('has-overflow');
        return;
      }

      var hasOverflow = track.scrollWidth - track.clientWidth > 1;
      carousel.classList.toggle('has-overflow', hasOverflow);

      if (!hasOverflow) return;

      // tolerancja 2px na zaokrąglenia
      var atStart = track.scrollLeft <= 1;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;

      prevBtn.classList.toggle('is-disabled', atStart);
      nextBtn.classList.toggle('is-disabled', atEnd);

      prevBtn.setAttribute('aria-disabled', atStart ? 'true' : 'false');
      nextBtn.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
    }

    function scrollBy(direction) {
      var step = getStep();
      track.scrollBy({ left: direction * step, behavior: 'smooth' });
    }

    prevBtn.addEventListener('click', function () {
      if (prevBtn.classList.contains('is-disabled')) return;
      scrollBy(-1);
    });

    nextBtn.addEventListener('click', function () {
      if (nextBtn.classList.contains('is-disabled')) return;
      scrollBy(1);
    });

    // obsługa klawiatury (Enter / Space) - bo to <div tabindex="0">, nie <button>
    [prevBtn, nextBtn].forEach(function (btn) {
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          btn.click();
        }
      });
    });

    // aktualizacja stanu strzałek przy scrollu (też ręcznym)
    var scrollTimeout;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(updateState, 50);
    }, { passive: true });

    // resize okna
    var resizeTimeout;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(updateState, 100);
    });

    // pierwsze sprawdzenie + nasłuch na dodanie/usunięcie produktów
    updateState();

    var observer = new MutationObserver(function () {
      updateState();
    });
    observer.observe(track, { childList: true, subtree: false });
  }

  function initAll(root) {
    var carousels = (root || document).querySelectorAll('[data-recommendations-carousel]');
    carousels.forEach(initCarousel);
  }

  // start
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Search & Discovery dociąga rekomendacje async - obserwujemy pojawienie się widżetu
  var bodyObserver = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches('[data-recommendations-carousel]')) {
          initCarousel(node);
        } else if (node.querySelectorAll) {
          initAll(node);
        }
      }
    }
  });
  bodyObserver.observe(document.body, { childList: true, subtree: true });
})();
